import React, { useState } from 'react';
import './App.css';
import Pagination from './Pagination';


function App() {
  const [steamId, setSteamId] = useState('');
  const [profileData, setProfileData] = useState(null);
  const [games, setGames] = useState([]);
  const [totalHours, setTotalHours] = useState(0);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(16); // 4x4 Grid = 16 items
  const [loading, setLoading] = useState(false);

  const fetchProfile = async () => {
    setError(null);
    setProfileData(null);
    setGames([]);
    setTotalHours(0);
    setCurrentPage(1);

    setLoading(true);

    try {
      // Convertir URL de perfil a Steam ID de 64 bits
      let steamId64 = steamId;
      if (steamId.includes('steamcommunity.com/id/')) {
        const vanityUrl = steamId.split('steamcommunity.com/id/')[1].split('/')[0];
        const resolveResponse = await fetch(`/api/steam?url=${encodeURIComponent(`https://api.steampowered.com/ISteamUser/ResolveVanityURL/v0001/?vanityurl=${vanityUrl}`)}`);
        const resolveData = await resolveResponse.json();
        if (resolveData.response.success === 1) {
          steamId64 = resolveData.response.steamid;
        } else {
          setError('No se pudo resolver la URL de Steam. Asegúrate de que sea correcta.');
          return;
        }
      } else if (steamId.includes('steamcommunity.com/profiles/')) {
        steamId64 = steamId.split('steamcommunity.com/profiles/')[1].split('/')[0];
      }

      // Obtener resumen del perfil
      const profileResponse = await fetch(`/api/steam?url=${encodeURIComponent(`https://api.steampowered.com/ISteamUser/GetPlayerSummaries/v0002/?steamids=${steamId64}`)}`);
      const profileData = await profileResponse.json();

      if (profileData.response.players.length > 0) {
        setProfileData(profileData.response.players[0]);
      } else {
        setError('No se encontró el perfil de Steam. Asegúrate de que la ID o URL sea correcta.');
        return;
      }

      // Obtener juegos del usuario
      const gamesResponse = await fetch(`/api/steam?url=${encodeURIComponent(`https://api.steampowered.com/IPlayerService/GetOwnedGames/v0001/?steamid=${steamId64}&format=json&include_appinfo=true`)}`);
      const gamesData = await gamesResponse.json();

      if (gamesData.response.games) {
        const sortedGames = gamesData.response.games.sort((a, b) => b.playtime_forever - a.playtime_forever);
        setGames(sortedGames);

        const totalPlaytime = sortedGames.reduce((total, game) => total + game.playtime_forever, 0);
        setTotalHours((totalPlaytime / 60).toFixed(1));
      }

    } catch (err) {
      setError('Ocurrió un error al obtener los datos. Revisa la consola para más detalles.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = games.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = pageNumber => setCurrentPage(pageNumber);

  return (
    <div className={`App ${profileData ? 'data-loaded' : ''}`}>
      <div className="top-controls">
        {profileData && (
          <button className="reset-button" onClick={() => {
            setProfileData(null);
            setGames([]);
            setSteamId('');
          }}>
            Nueva Búsqueda
          </button>
        )}
      </div>

      {profileData ? (
        <div className="main-content">
          <div className="profile-container">
            <h2>{profileData.personaname}</h2>
            <img src={profileData.avatarfull} alt="Avatar de Steam" />
            <div className="profile-details">
              <p><span>País:</span> {profileData.loccountrycode || 'N/A'}</p>
              <p><span>Perfil:</span> <a href={profileData.profileurl} target="_blank" rel="noopener noreferrer">Ver en Steam</a></p>
              <p><span>ID de Steam:</span> {profileData.steamid}</p>
              {profileData.timecreated && (
                <p>
                  <span>Fecha de creación:</span> {
                    new Date(profileData.timecreated * 1000).toLocaleDateString()
                  }
                </p>
              )}
              <p><span>Juegos:</span> {games.length}</p>
              <p><span>Horas de juego totales:</span> {totalHours}</p>
            </div>
          </div>
          {games.length > 0 && (
            <div className="games-container">
              <h3>Juegos con más horas</h3>
              <div className="games-grid">
                {currentItems.map(game => (
                  <div key={game.appid} className="game-card">
                    <div className="game-image">
                      <img
                        src={`http://media.steampowered.com/steamcommunity/public/images/apps/${game.appid}/${game.img_icon_url}.jpg`}
                        alt={game.name}
                        onError={(e) => { e.target.onerror = null; e.target.src = "https://via.placeholder.com/64?text=?" }}
                      />
                    </div>
                    <div className="game-info">
                      <h4>{game.name}</h4>
                      <span className="playtime">{(game.playtime_forever / 60).toFixed(1)} horas</span>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination
                itemsPerPage={itemsPerPage}
                totalItems={Math.min(games.length, itemsPerPage * 3)} // Limit pagination to max 3 pages
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="search-container">
          <h1>Ingresa el url de tu perfil de steam</h1>
          <div className="search-box">
            <input
              type="text"
              value={steamId}
              onChange={(e) => setSteamId(e.target.value)}
              placeholder="Ingresa tu ID de Steam o URL de perfil"
              onKeyPress={(e) => e.key === 'Enter' && fetchProfile()}
            />
            <button onClick={fetchProfile}>Buscar</button>
          </div>
          <div className="privacy-notice">
            <p>Este sitio fue desarrollado con la finalidad de practicar mis habilidade de programación. Todos los datos están seguros y se obtienen utilizando la API pública de Steam.</p>
          </div>
        </div>
      )}

      {error && <p className="error">{error}</p>}

      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>FETCHING PROFILE...</p>
        </div>
      )}
    </div>
  );
}
export default App;